var render, staticRenderFns
import script from "./StatsChart.vue?vue&type=script&lang=js"
export * from "./StatsChart.vue?vue&type=script&lang=js"
import style0 from "./StatsChart.vue?vue&type=style&index=0&id=23f375f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f375f9",
  null
  
)

export default component.exports